<template>
  <div class="simple-table">
    <Heading level="h5" v-if="!!title" class="simple-table__title">{{title}}</Heading>
    <div class="simple-table__description" v-if="!!$scopedSlots['description']">
      <slot name="description"></slot>
    </div>
    <div class="simple-table__wrapper binds-mt-2">
      <table class="simple-table__wrapper__table" cellspacing="0" cellpadding="0" border="0">
        <thead v-if="!!$scopedSlots['description']">
          <tr class="simple-table__wrapper__table__head">
            <slot name="header"></slot>
          </tr>
        </thead>
        <tbody>
          <tr
            class="simple-table__wrapper__table__row"
            v-for="(item, index) in itemsList"
            :key="item._uuid"
          >
            <slot name="item" v-bind:item="item" v-bind:$index="index"></slot>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Input from "../Form/Input";
import Heading from '../Typography/Heading.vue';
export default {
  name: "AppTable",
  status: "prototype",
  release: "1.0.0",
  components: { Input, Heading },
  props: {
    title: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    itemsList() {
      return this.items.map((item, index) => {
        return {
          ...item,
          _uuid: index,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.simple-table {
  @include reset();
  padding: 20px;
  font-family: $font-text;
  background-color: $color-white;
  border-radius: 5px;
  box-shadow: 1px 2px 5px 0 rgba(119, 151, 178, 0.25);
  &__description {
    font-size: $size-s;
    line-height: 1.38;
    color: $color-gray;
  }
  &__wrapper {
    position: relative;
    overflow: hidden;
    overflow-x: auto;
    &__table {
      min-width: 100%;
      &__head {
        th, td {
          padding: 10px 20px;
          font-weight: normal;
          font-size: $size-xs;
          line-height: 1;
          color: $color-gray-darker;
          background-color: $color-ice;
          text-align: left;
        }
      }
      &__row {
        background-color: $color-ice;
        &:nth-child(odd) {
          background-color: $color-white;
        }
        td {
          padding: 10px 20px;
          font-size: $size-s;
          line-height: 1;
          color: $color-purple-darker;
          text-align: left;
          white-space: nowrap;
          word-break: keep-all;
        }
      }
    }
  }
}
</style>
